import BookingForm from "./bookingForm";


declare global {
	const playersRangeLabel: string;
	const errorAlertMsg: string;
	const missingPlayerCount: string;
	const requiredTime: string;
	const requiredField : string;
	const emailError : string;
	const phoneError : string;
	const numberError : string;
	const numberMinError : string;
	const numberMaxError : string;
}

export default function initBooking() {

	const form = document.getElementById('booking-form') as HTMLFormElement;

	const bookingForm = new BookingForm(form);

}